import { GQL } from "@binale-tech/shared";

import { DmsType } from "@domain/models/dms";

import { withThinking } from "../runner/runAgent";
import type { AgentStep, ReportLine } from "../runner/types";
import { isInYear } from "./inYear";

const EXCLUDED_TYPES: string[] = [DmsType.new_documents, DmsType.trash];

export const documentContactsStep: AgentStep = {
    id: "documentContacts",
    product: [GQL.IProductKey.Dms, GQL.IProductKey.Contacts],
    async run(ctx, io) {
        const ids = [...ctx.documents().values()]
            .filter(
                (doc) => !EXCLUDED_TYPES.includes(doc.type) && !doc.contactId && isInYear(doc.documentDate, ctx.year),
            )
            .map((doc) => String(doc.key));
        if (ids.length === 0) return { status: "nothing" };

        const { linked, created } = await withThinking(io, "app.agent.documentContacts.thinking", async () => {
            const filled = await ctx.fillDocumentContacts(ids);
            const rest = ids.filter((id) => !filled.includes(id));
            const summary = rest.length > 0 ? await ctx.createDocumentContacts(rest) : undefined;
            return { linked: filled.length, created: summary?.createdContacts.length ?? 0 };
        });
        if (linked === 0 && created === 0) return { status: "nothing" };

        io.post({ kind: "done", textId: "app.agent.documentContacts.done", values: { linked, created } });
        const summary: ReportLine[] = [];
        if (linked > 0) summary.push({ textId: "app.agent.report.documentContactsLinked", values: { count: linked } });
        if (created > 0)
            summary.push({ textId: "app.agent.report.documentContactsCreated", values: { count: created } });
        return { status: "done", summary };
    },
};
